import { IconComponentConfig } from '../icon';

export interface SelectPopoverConfig {
  title?: string;
  content?: string;
  titleIcon?: IconComponentConfig;
  contentIcon?: IconComponentConfig;
  placement?: string;
  size?: string;
}
